import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { syncEntireCase } from "../../../lib/fetchApi"
import { notificationActions } from "../../../store/notifications"
import BodySimpleModalV3 from "../../common/modal/BodySimpleModalV3"
import Button from "../../common/Button"
import RemoveDataConfirmationModal from "../../common/RemoveDataConfirmationModal"
import { useCaseSynced } from "../../../lib/socketHooks"

export default function SyncEntireCase() {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [isWaitingForSocket, setIsWaitingForSocket] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)
    const timeoutRef = useRef(null)

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
                timeoutRef.current = null
            }
        }
    }, [])

    useCaseSynced(
        activeCase?.case?.id,
        () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
                timeoutRef.current = null
            }
            dispatch(notificationActions.setError({ errorMessage: 'Case synced successfully', type: 'success' }))
            setLoading(false)
            setIsWaitingForSocket(false)
        },
        isWaitingForSocket
    )

    const syncEntireCaseHandler = async () => {
        setShowConfirm(false)
        setLoading(true)
        try {
            const data = await syncEntireCase(userToken, activeCase.case.id)

            if (data && data.errorMessage) {
                dispatch(notificationActions.setError(data))
                setLoading(false)
                setIsWaitingForSocket(false)
            } else {
                dispatch(notificationActions.setError({ errorMessage: 'Case syncing in background...', type: 'success' }))
                setIsWaitingForSocket(true)
            }
        } catch (error) {
            setLoading(false)
            setIsWaitingForSocket(false)
        }
    }

    return <>
    {activeCase && activeCase.patient && activeCase.patient.person_number && activeCase.patient.person_number != '' && <div style={{ position: 'relative' }}>
        <BodySimpleModalV3 message={'Sync Entire Case'} widthAuto={true}>
            <Button click={() => setShowConfirm(true)} square={true} isLoading={loading} bypassisCaseArchived={true}>
                <i className='ti ti-rotate-clockwise-2'></i>
            </Button>
        </BodySimpleModalV3>
        {showConfirm && <RemoveDataConfirmationModal
            closeModal={() => setShowConfirm(false)}
            removeData={syncEntireCaseHandler}
            message={'Are you sure you want to sync the entire case?'}
            confirmLabel={'Sync'}
            position={'right'}
        />}
    </div>}
    </>
}
